import { Component, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { Jurisdiction, IJurisdiction } from '../../../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { VehicleModel } from '../../../../vehicle/models/vehicle.model';
import { VehicleService } from '../../../../vehicle/services/vehicle.service';
import { VehicleBrandsModel } from '../../../../vehicle/shared/vehicle-brands/vehicle-brands.model';
import { TransactionService } from '../../../services/transaction.service';
import { NMVTISMessageModel } from '../../models/nmvtis-message.model';
import { BrandDesignation, VehicleDesignationModel } from '../../models/vehicle-designation-model';
import { Brand, IBrand } from '../../../../vehicle/models/enums/brand.enum';
import { BrandNmvtisBrandMapModel } from '../../../../vehicle/shared/vehicle-brands/brand-nmvtis-brand-map';
import { INMVITSBrand, NMVITSBrand } from '../../../../vehicle/models/enums/nmvits-brand.enum';
import { BusinessTransactionType } from '@max/foundation/models/enums/business-transaction-type.enum';
import { forEach } from '../../../../../node_modules/@angular-devkit/schematics';
import { BusinessTransactionService } from '../../../../shared/services/business-transaction/business-transaction.service';
import { SourceSystemType } from '../../../../foundation/models/enums/source-system-type.enum';

@Component({
    selector: 'vehicle-brands-message',
    templateUrl: './vehicle-brands-message.html',
    inputs: ['nmvtisMessageModel'],
    outputs: ['onSaved', 'onCancel']

})
// should be called only in case of title transactions and Registration transactions.
export class VehicleBrandsMessageComponent extends BaseComponent {

    public dataLoaded = false;
    public message: string;
    public onSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
    private vehicle: VehicleModel;
    private businessTransactionNumber: number;
    public nmvtisMessageModel: NMVTISMessageModel;
    public vehicleDesignationList: VehicleDesignationModel[];
    public lookups: any;
    public nmvtisBrands: any[];
    public brand: Brand = new Brand();
    public allBrands: IBrand[];
    public metadata: any; // business transaction metadata

    public nmvtisBrand = new NMVITSBrand();
    public allNmvtisBrands: INMVITSBrand[];

    private isNewer = true;

    private jurisdiction: Jurisdiction = new Jurisdiction();
    private businesstransactionType: BusinessTransactionType = new BusinessTransactionType();
    constructor(private _vehicleService: VehicleService,
        private _transactionService: TransactionService,
        private _route: ActivatedRoute,
        private _businessTransactionService: BusinessTransactionService) {
        super();

        this.businessTransactionNumber = +_route.snapshot.params['id']; // grab the business transaction from the route.

    }

    async ngOnInit() {
        this.vehicleDesignationList = <VehicleDesignationModel[]> this.nmvtisMessageModel.nmvtisResponse.vehicleDesignations;

        this.allBrands = this.brand.GetAll(); // max brands
        this.allNmvtisBrands = this.nmvtisBrand.GetAll(); // nmvtis brands

        if (!this.businessTransactionNumber) { // TODO: verify if this is the right approach
            this.businessTransactionNumber = this.nmvtisMessageModel.businessTransactionId;
        }

        let businessTransactionTypeId = await this._transactionService.getTransactionTypeByBusinessTransactionId(this.businessTransactionNumber).pipe(first()).toPromise();
        this.message = 'The following brands have been found on NMVTIS. Alert the customer.';

        this.metadata = await this._businessTransactionService.getTransactionMetaData(this.nmvtisMessageModel.businessTransactionId.toString()).pipe(first()).toPromise();
        if (this.metadata.sourceSystemTypeId == new SourceSystemType().IRP.id) {
            this.vehicle = await this._vehicleService.getIRPVehicleByBusinessTransactionId(this.businessTransactionNumber).pipe(first()).toPromise();
        } else {
            this.vehicle = await this._vehicleService.getVehicleByBusinessTransactionId(this.businessTransactionNumber).pipe(first()).toPromise();
        }

        // convert the nmvtis code to the max brand code. Grab the mapping
        let brandNmvtisBrandMaps: BrandNmvtisBrandMapModel[] = await this._vehicleService.getBrandNMVITSBrandMaps().pipe(first()).toPromise();

        this.vehicle.nmvtisBrands = [];
        this.nmvtisBrands = [];

        for (const vd of this.vehicleDesignationList) {
            if (!vd.brandDesignation) { // brand designations might be missing from response. 79743
                continue;
            }
            var brandMap = brandNmvtisBrandMaps.find(s => s.nmvitsBrandId == +vd.brandDesignation.vehicleBrandCode);
            if (!brandMap) {
                continue;
            }
            var b = this.brand.FromId(brandMap.brandId);
            var nb = this.nmvtisBrand.FromId(brandMap.nmvitsBrandId);

            const brandDesignation = new BrandDesignation();
            brandDesignation.nmvtisDisplayValue = nb.displayValue;
            brandDesignation.vehicleBrandName = b.displayValue;
            brandDesignation.vehicleBrandDate = vd.brandDesignation.vehicleBrandDate;
            brandDesignation.reportingEntityName = vd.reportingEntity.entityName;
            brandDesignation.isRecognized = b.isRecognized;
            this.nmvtisBrands.push(brandDesignation);

            // add all the nmvtis brands to the transaction. refer cc 42791
            const newBrand = new VehicleBrandsModel();
            newBrand.vehicleID = this.vehicle.id;
            newBrand.brandID = b.id;
            newBrand.brandAppliedDate = new Date();
            newBrand.effectiveDate = vd.brandDesignation.vehicleBrandDate;
            newBrand.id = -1;

            // refer bug 51840. This needs to be Jurisdiction code. The az brands should be filtered on the server as the client has no knowledge of config values
            // newBrand.jurisdictionID = +vd.reportingEntity.identificationId;
            // newBrand.jurisdictionID = new Jurisdiction().FromCode(vd.reportingEntity.identificationId).id;
            // don't use FromCode. some of the reporting entities like S7 don't exist in MAX
            let nmvtisJurisdiction: IJurisdiction = this.jurisdiction.GetAll().find(s => s.code == vd.reportingEntity.identificationId);
            // newBrand.jurisdictionID = this.jurisdiction.GetAll().find(s => s.code == vd.reportingEntity.identificationId).id;

            // only add to MAX when the brand is recognized in MAX
            if (nmvtisJurisdiction && b.isRecognized) {
                newBrand.jurisdictionID = nmvtisJurisdiction.id;
                this.vehicle.nmvtisBrands.push(newBrand);
            }
        }

        if (this.vehicle.nmvtisBrands.length > 0) {
            this.vehicle.nmvtisBrands.sort((b, a) => moment(a.effectiveDate).diff(moment(b.effectiveDate))); // sort by effective Date so that we get the latest one

            if (this.businesstransactionType.RegistrationOnly.id != businessTransactionTypeId && this.businesstransactionType.IssuePermit.id != businessTransactionTypeId) {

                let activeBrands: VehicleBrandsModel[] = await this._vehicleService.getVehicleBrandsByVehicleId(this.vehicle.id).pipe(first()).toPromise();

                if (activeBrands && activeBrands.length) {
                    for (var activeBrand of activeBrands) {
                        if (activeBrand.effectiveDate > this.vehicle.nmvtisBrands[0].effectiveDate) {
                            this.message = 'None of the following brands from NMVTIS will be added to the vehicle since active brand on the vehicle is newer.';
                            this.isNewer = false;
                            break;
                        }
                    }
                }
            } else if (this.businesstransactionType.RegistrationOnly.id == businessTransactionTypeId) {
                // guard against specific scenario where arizona has a restored salvage after nmvtis salvage brand.
                let activeBrands: VehicleBrandsModel[] = await this._vehicleService.getVehicleBrandsByVehicleId(this.vehicle.id).pipe(first()).toPromise();

                if (activeBrands && activeBrands.length) {
                    let lastnmvtisBrand = this.vehicle.nmvtisBrands[0];

                    if (lastnmvtisBrand.brandID == this.brand.Salvage.id) {
                        for (var activeBrand of activeBrands) {
                            if (activeBrand.brandID == this.brand.RestoredSalvage.id && activeBrand.effectiveDate > lastnmvtisBrand.effectiveDate) {
                                this.message = 'None of the following brands from NMVTIS will be added to the vehicle since active brand on the vehicle is newer.';
                                this.isNewer = false;
                                break;
                            }
                        }
                    }
                }
            }

            if (this.isNewer) {
                this.vehicle.newVehicleBrand = new VehicleBrandsModel();
                this.vehicle.newVehicleBrand.brandID = this.vehicle.nmvtisBrands[0].brandID; // add one automatically for CSR
                this.vehicle.newVehicleBrand.id = -1;
                this.vehicle.newVehicleBrand.vehicleID = this.vehicle.id;
                this.vehicle.newVehicleBrand.brandAppliedDate = new Date();
                this.vehicle.newVehicleBrand.effectiveDate = new Date();
                this.vehicle.newVehicleBrand.jurisdictionID = this.vehicle.nmvtisBrands[0].jurisdictionID;

                if (this.businesstransactionType.RegistrationOnly.id == businessTransactionTypeId
                    || this.businesstransactionType.IssuePermit.id == businessTransactionTypeId) {

                    let validRegistrationBrands: number[] = [this.brand.RestoredSalvage.id, this.brand.Reconstructed.id, this.brand.Refurbished.id, this.brand.Retrofit.id, this.brand.StateAssignedVIN.id];
                    var latestBrandDate = this.vehicle.nmvtisBrands[0].effectiveDate;

                    for (var brand of this.vehicle.nmvtisBrands) {
                        if (brand.effectiveDate == latestBrandDate && validRegistrationBrands.indexOf(brand.brandID) > -1) {
                            this.vehicle.newVehicleBrand.brandID = brand.brandID;
                            this.vehicle.newVehicleBrand.jurisdictionID = brand.jurisdictionID;
                            break;
                        }
                    }

                } else {
                    this.vehicle.newVehicleBrand.jurisdictionID = 4; // Make it AZ brand before adding to the title transactions
                    this.message += ' The brand: ' + this.brand.GetAll().find(s => s.id == this.vehicle.nmvtisBrands[0].brandID).displayValue + ' has been added to the vehicle.';
                }
            }
        }

        this.dataLoaded = true;
    }

    async onSaveClick() {
        if (this.isNewer && this.dataLoaded) {
            if (this.metadata.sourceSystemTypeId == new SourceSystemType().IRP.id) {
                await this._transactionService.updateIRPVehicleBrands(this.businessTransactionNumber, this.vehicle).pipe(first()).toPromise();
            } else {
                await this._transactionService.updateVehicleBrands(this.businessTransactionNumber, this.vehicle).pipe(first()).toPromise();
            }
        }
        this.onSaved.emit(true);
    }

    onCancelClick() {
        this.onCancel.emit(true);
    }
}
